import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import HeaderApp from "../../components/HeaderApp";
import TableNoticiasEventos from "../../components/TableNoticiasEventos";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const NoticiasEventos = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderApp />
      <Box
        component="main"
        sx={{
          flex: 1,
          py: 4,
          px: 2,
          bgcolor: "background.default",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={3}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Noticias y eventos
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate("/NoticiasEventos/nueva")}
            >
              Agregar noticia o evento
            </Button>
          </Box>
          <TableNoticiasEventos />
        </Container>
      </Box>
    </>
  );
};

export default NoticiasEventos;
